/* Local dependencies */
import { Warehouse } from '../../types';

export enum CreateWarehouseActionTypes {
  CREATE_WAREHOUSE = 'CREATE_WAREHOUSE',
  CREATE_WAREHOUSE_SUCCESS = 'CREATE_WAREHOUSE_SUCCESS',
  CREATE_WAREHOUSE_ERROR = 'CREATE_WAREHOUSE_ERROR',
  CREATE_WAREHOUSE_RESET_ERROR = 'CREATE_WAREHOUSE_RESET_ERROR',
  CREATE_WAREHOUSE_RESET_STATE = 'CREATE_WAREHOUSE_RESET_STATE',
}

export interface CreateWarehouseInput {
  address: string;
  city: string;
  region: string;
  country: string;
  postcode: string;
  phone: string;
}

export interface CreateWarehouseRequest {
  type: CreateWarehouseActionTypes.CREATE_WAREHOUSE;
  input: CreateWarehouseInput;
}

export interface CreateWarehouseSuccess {
  type: CreateWarehouseActionTypes.CREATE_WAREHOUSE_SUCCESS;
  warehouse: Warehouse;
}

export interface CreateWarehouseError {
  type: CreateWarehouseActionTypes.CREATE_WAREHOUSE_ERROR;
  error: Error;
}

export interface ResetCreateWarehouseError {
  type: CreateWarehouseActionTypes.CREATE_WAREHOUSE_RESET_ERROR;
}

export interface ResetCreateWarehouseState {
  type: CreateWarehouseActionTypes.CREATE_WAREHOUSE_RESET_STATE;
}

export type CreateWarehouseAction =
  | CreateWarehouseRequest
  | CreateWarehouseSuccess
  | CreateWarehouseError
  | ResetCreateWarehouseError
  | ResetCreateWarehouseState;
